<template>
    <div>
        <loading :loading="loading"></loading>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <div v-if="editing">
                    <edit-user :close-edit="stopEditing" :user="user"></edit-user>
                </div>
                <ion-card color="primary" v-else>
                    <ion-card-header>
                        <ion-card-subtitle class="text-center u-mb2">
                            <ion-avatar class="big-avatar" v-if="user.is_creator">
                                <img :src="user.avatar" v-if="user.avatar">
                                <img src="../assets/ghost-avatar-white.png" class="dark-img" v-else>
                            </ion-avatar>
                            <span v-else>
                                {{user.email}}
                            </span>
                        </ion-card-subtitle>
                        <ion-card-title>
                            {{user.name}}
                        </ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <div v-html="nl2br(user.profile)" v-if="user.is_creator"></div>
                        <div class="u-mt1 u-mb1">
                            <ion-button shape="round" expand="full" v-on:click="editProfile()">Edit</ion-button>
                            <ion-button shape="round" expand="full" v-on:click="upgradeProfile()">Upgrade</ion-button>
                        </div>
                        <div v-if="user.is_creator" class="profile-info">
                            <hr>
                            <div v-if="user.storage">
                                You have used {{user.storage}}
                            </div>
                            <div v-if="user.years">
                                You have subscribed for {{user.years}} years.<br>
                                Your storage will expire on {{dateFormat(user.expires_at, 'Do MMMM YYYY')}}.
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
            </div>
        </div>
        <return-home />
    </div>
</template>

<script>
import ReturnHome from '@/components/ReturnHome.vue'
import EditUser from '@/components/EditUser.vue'
import {auth} from '@/mixins/auth';
import {userdetails} from '@/mixins/userdetails';
import {formatting} from '@/mixins/formatting';

export default {
    name: 'profile',
    data : function () {
        return {
            editing : false
        }
    },
    mounted : function () {
        this.getUserDetails();
    },
    components: {
        ReturnHome, EditUser
    },
    mixins : [auth, userdetails, formatting],
    computed : {
        //
    },
    methods : {
        getUserDetails : function () {
            let self = this;
            this.loading = true;
            this.axios.post(this.api + 'auth/me')
                .then(response => {
                    console.debug('Got User Details', response.data);
                    self.$root.setUser(response.data);
                    self.loading = false;
                })
                .catch(error => {
                    console.error('ERROR getting me', error);
                    self.loading = false;
                });
        },
        back : function () {
            this.$router.push({name : 'home'});
        },
        editProfile : function () {
            this.editing = true;
        },
        stopEditing : function () {
            this.editing = false;
        },
        upgradeProfile : function () {
            this.upgrading = true;
            this.$router.push({name : 'upgrade'});
        }
    }
}
</script>